// Each of these values maps to the DB Identifier in the InvoiceCenter table
export default Object.freeze({
  TEACHING_MELBOURNE: 1, // Teaching Melbourne
  EARLY_CHILDHOOD_VIC_AUS: 2, // Early Childhood - VIC - AUS
  EARLY_CHILDHOOD_CITY_OF_CASEY: 3, // Early Childhood - City of Casey
  TEACHING_UK: 4, // Teaching UK
  EARLY_CHILDHOOD_COMENSURA: 5, // Early Childhood - Comensura
  TEACHING_USA: 6, // Teaching USA
  TEACHING_NZ: 8, // Teaching NZ
})
